module.exports = __webpack_public_path__ + "img/blt-login.2325b60f.svg";